<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <i class="fa fa-list"></i>
          <strong>
            {{ title }}
            <b-spinner v-if="loading" class="float-right" small></b-spinner>
          </strong>
        </div>
        <div>
          <div>
            <b-form>
              <b-row>
                <b-col>
                  <label for="monthSelect">Seleccione mes</label>
                  <b-form-select
                    id="monthSelect"
                    v-model="selected.month"
                    :plain="true"
                    :options="selectOptions.months"
                    value="Seleccione..."
                  >
                  </b-form-select>
                </b-col>
                <b-col>
                  <label for="yearSelect">Año</label>
                  <b-form-select
                    id="yearSelect"
                    v-model="selected.year"
                    :plain="true"
                    :options="selectOptions.years"
                    value="Seleccione..."
                  >
                  </b-form-select>
                </b-col>
              </b-row>
            </b-form>
          </div>
          <hr />
          <v-server-table
            :url="url"
            :columns="columns"
            :options="options"
            :theme="theme"
            ref="table"
            id="dataTable"
          >
            <template slot="status" slot-scope="props">
              <b-badge pill :variant="getBadge(props.row.status)">
                {{ props.row.status }}
              </b-badge>
            </template>

            <div class="text-center" slot="actions" slot-scope="props">
              &nbsp;
              <a
                target="_blank"
                href="#"
                @click.prevent="openReport(props.row)"
                class="fa fa-lg fa-search text-primary"
                title="reporte"
              ></a
              >&nbsp;
            </div>
          </v-server-table>
        </div>
      </b-card>
      <b-modal
        id="modal-process-report"
        ref="reportModal"
        centered
        size="xl"
        title="Detalle de proceso"
        @ok="
          report = null;
          data = null;
        "
        @hide="
          report = null;
          data = null;
        "
        ok-only
      >
        <div class="text-center">
          <b-spinner v-if="loading" label="Spinning"></b-spinner>
        </div>
        <component
          :is="report"
          :process_type="process_type_id"
          :process_date="process_date"
          :process_type_name="process_type_name"
        ></component>
      </b-modal>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import Report from "./ProcessReport";
import Report2 from "./ProcessReport2";

numeral.locale("es");
window.axios = require("axios");

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "ProcessList",
  components: {
    ServerTable,
    Report,
    Report2
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });

    this.loadYear();
  },
  data() {
    return {
      title: "Listado de procesos",
      loading: false,
      report: "report",
      process_type_id: "",
      process_date: "",
      process_type_name: "",
      selected: {
        month: d.getMonth() + 1,
        year: d.getFullYear()
      },
      selectOptions: {
        months: [
          { value: 1, text: "Enero" },
          { value: 2, text: "Febrero" },
          { value: 3, text: "Marzo" },
          { value: 4, text: "Abril" },
          { value: 5, text: "Mayo" },
          { value: 6, text: "Junio" },
          { value: 7, text: "Julio" },
          { value: 8, text: "Agosto" },
          { value: 9, text: "Septiembre" },
          { value: 10, text: "Octubre" },
          { value: 11, text: "Noviembre" },
          { value: 12, text: "Diciembre" }
        ],
        years: []
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields2: {
        Exportadora: "client_customer_name"
      }, //, "sum_net_kilograms"
      columns: [
        "date",
        "process_type__name",
        "sum_net_kilograms",
        "quantity",
        "actions"
      ],
      report_data: null,
      theme: "bootstrap4",
      template: "default",
      options: {
        responseAdapter: function(resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            items.push(item);
          }
          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        filterByColumn: true,
        filterable: [
          "date",
          "process_type__name",
          "sum_net_kilograms",
          "quantity"
        ],
        listColumns: {
          status: [
            { id: "Abierto", text: "Abierto" },
            { id: "Cerrado", text: "Cerrado" }
          ]
        },
        headings: {
          date: "Fecha",
          process_type__name: "Tipo",
          sum_net_kilograms: "Kilos Netos",
          quantity: "Cantidad",
          actions: " "
        },
        debounce: 800,
        columnsDropdown: false,
        pagination: {
          dropdown: false,
          chunk: 10
        }
      }
    };
  },
  filters: {
    moment(value) {
      return moment(value).format("DD-MM-YYYY");
    }
  },
  computed: {
    name() {
      return "Stock " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    },
    url() {
      return (
        "/bagno/process-daily/?" +
        "month=" +
        this.selected.month +
        "&year=" +
        this.selected.year
      );
    }
  },
  methods: {
    loadYear() {
      for (let ano = 2019; ano <= d.getFullYear(); ano++) {
        this.selectOptions.years.push({ value: ano, text: ano });
      }
    },
    editProcess(a) {
      this.$router.push({ name: "bagno-procesos-ingreso", params: a });
    },
    editProcess2(a) {
      this.$router.push({ name: "bagno-procesos-ingreso2", params: a });
    },
    openReport(a) {
      this.process_type_id = a.process_type__id;
      this.process_date = a.date;
      this.process_type_name = a.process_type__name;
      this.report = Report2;
      this.$bvModal.show("modal-process-report");
    },
    jsonToQueryString(json) {
      var result = {};
      for (var key in json) {
        if (json[key] !== "") {
          result[key] = json[key];
        }
      }
      var a = encodeURIComponent(JSON.stringify(result));
      return "/api/v1/stock/?query=" + a;
    },
    resetFilters() {
      for (var key in this.$refs["table"].query) {
        this.$refs["table"].query[key] = "";
      }
      this.$refs["table"].refresh();
    },
    getBadge(status) {
      return status === "Abierto" ? "light" : "dark";
    },
    async fetchData() {
      const response = await this.$axios.get(
        this.jsonToQueryString(this.$refs.table.query)
      );
      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
    padding: 0.25rem;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__columns-dropdown {
    padding-right: 20px;
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
